import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { useAdsStyles } from '../../../../../../util/styles/hooks/useAdsStyles.js';
import { mergeProps } from '@react-aria/utils';
import { useCarouselV3Context } from '../../../hooks/useCarouselV3Context.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useItem = function useItem(props, ref) {
  var _props$flexBasis;
  var _useCarouselV3Context = useCarouselV3Context(),
    gap = _useCarouselV3Context.gap;
  var _useAdsStyles = useAdsStyles(),
    mapAdsStyles = _useAdsStyles.mapAdsStyles;
  var styles = mapAdsStyles({
    minWidth: 0,
    flexShrink: 0,
    flexGrow: 0,
    flexBasis: (_props$flexBasis = props.flexBasis) !== null && _props$flexBasis !== void 0 ? _props$flexBasis : '100%',
    ps: gap
  });
  var mergedProps = mergeProps(styles, props);
  var itemProps = _objectSpread({
    ref: ref,
    role: 'group'
  }, mergedProps);
  return {
    itemProps: itemProps
  };
};

export { useItem };
//# sourceMappingURL=useItem.js.map
